import { useState } from 'react'
import { useStore } from '@moonpig/web-core-stores'
import { useRouter } from '@moonpig/web-core-routing'
import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql'
import { useAddDigitalGiftToBasket } from './useAddDigitalGiftToBasket'
import { Journeys } from './Journeys'
import { Variant } from '../../types'
import {
  GetBasket_me_basket_lineItems as LineItem,
  GetBasket_me_basket_lineItems_design as Design,
} from './types'

export type CardLineItem = Omit<LineItem, 'design'> & {
  design: Design & { coverImageUrl: string }
}

export const useAddDigitalGiftToExistingCard = () => {
  const { addDigitalGiftToBasket } = useAddDigitalGiftToBasket()
  const [loading, setLoading] = useState(false)
  const {
    store: { id: region },
  } = useStore()
  const router = useRouter()

  const addDigitalGiftToExistingCard = async ({
    basketId,
    existingCard,
    variant,
    department,
  }: {
    existingCard: CardLineItem
    basketId: string
    variant: Variant
    department: DepartmentsEnum
  }) => {
    setLoading(true)
    try {
      await addDigitalGiftToBasket({
        basketId,
        variant: {
          ...variant,
          addons: [],
        },
        region,
        lastLineItem: existingCard,
        department,
      })

      router.push({
        name: 'customise-edit',
        params: {
          designId: existingCard.design.id,
          journey: Journeys.EXPERIENCE_GIFT_FIRST_EXISTING,
          region,
          variantKey: '1',
        },
      })
    } finally {
      setLoading(false)
    }
  }
  return { addDigitalGiftToExistingCard, loading }
}
